var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueEditor',{attrs:{"editor-toolbar":_vm.customToolbar,"placeholder":_vm.$t('taskAssignment.additional_content.placeholder')},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }